<template>
  <div>
    <SearchResult
        v-for="result in results"
        :key="result._id"
        :title="mappedData[result._source.content_type].title(result)"
        :description="mappedData[result._source.content_type].description(result, term)"
        :type="mappedData[result._source.content_type].type(result)"
        :image="mappedData[result._source.content_type].image(result)"
        :unitID="mappedData[result._source.content_type].unitID(result)"
        :term="term"
        :link="mappedData[result._source.content_type].link(result, getUnit(mappedData[result._source.content_type].unitID(result)).slug, term)"
        :fullTags="result._source.tags"
        :unit="getUnit(mappedData[result._source.content_type].unitID(result))">
      </SearchResult>
      <slot></slot>
  </div>
</template>

<script>
import SearchResult from './FHSearchResult'
import mappedData from './mapResults.js'

export default {
  name: "SearchResultsCont",

  components: {
    SearchResult
  },

  props: {
    term: String,
    results: Array,
    units: Array
  },

  computed: {
    getUnit() {
      return unitID => {
        let units = this.units.filter(unit => unit.id === unitID)
        if (units.length == 0) {
          return null
        }
        return units[0]
      }
    }
  },

  data: function() {
    return {
      mappedData: mappedData
    }
  }
}
</script>
